import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';

/**
 * Generated class for the CoAppSelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-app-selector',
  templateUrl: 'co-app-selector.html',
})
export class CoAppSelectorPage {

  selectedApp: any;
  appIdList: Array<any>;
  constructor(public navCtrl: NavController, public navParams: NavParams, private events : Events, private config : ConfigProvider) {
    if (navParams.get('apps')) {
      this.appIdList = navParams.get('apps');
    } else {
      this.config.getAllApps().then( res =>{
        // console.log(res);
        if (res){
          this.appIdList = res;
          this.appIdList.sort((a,b)=>{
            return (a.id < b.id)? -1 : (a.id > b.id)? 1 : 0;
          })
        }
      });
    }


  }

  selectApp(){
    this.events.publish('SelectedAppId', {id: this.selectedApp.id, clientId: this.selectedApp.clientId});
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-app-selector/co-app-selector.ts